import { Modal } from "antd";
import { FaCrown } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { RouteName } from "constant/routeNames";

interface PremiumContentModalProps {
  isOpen: boolean;
  onClose: () => void;
  isCreator?: boolean;
  packageObject?: any;
}

export const PremiumContentModal = ({
  isOpen,
  onClose,
  isCreator = false,
  packageObject,
}: PremiumContentModalProps) => {
  const navigate = useNavigate();

  return (
    <Modal
      title={null}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
      className="premium-modal"
      styles={{
        content: {
          backgroundColor: "#0c0c0c",
          border: "1px solid #262626",
          borderRadius: "16px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <div className="relative flex flex-col items-center px-8 pb-8 pt-10 text-center">
        {/* Ambient glow behind the crown, kept subtle and off-center so it reads as light rather than a decal */}
        <div
          className="pointer-events-none absolute left-1/2 top-0 h-40 w-40 -translate-x-1/2 -translate-y-1/3 rounded-full opacity-30 blur-3xl"
          style={{ background: "radial-gradient(circle, #E8B04B, transparent 70%)" }}
        />

        <div
          className="relative mb-5 flex h-16 w-16 items-center justify-center rounded-full"
          style={{
            background: "linear-gradient(155deg, #2a2210 0%, #17140a 100%)",
            border: "1px solid #4a3a17",
          }}
        >
          <FaCrown className="text-2xl" style={{ color: "#E8B04B" }} />
        </div>

        {isCreator ? (
          <>
            <h3 className="mb-2 text-xl font-semibold tracking-tight text-white">
              Creator content is locked
            </h3>
            <p className="mb-7 max-w-[280px] text-sm leading-relaxed text-gray-400">
              Subscribe to this creator to watch this and everything else they publish.
            </p>
            <div className="flex w-full gap-3">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 rounded-lg border border-[#333] px-4 py-2.5 text-sm font-medium text-gray-400 transition-colors hover:border-[#555] hover:text-white"
              >
                Not now
              </button>
              <button
                type="button"
                onClick={() => {
                  onClose();
                  navigate(RouteName.SubscriptionPlanCheckout, {
                    state: { plan: packageObject },
                  });
                }}
                className="flex-1 rounded-lg px-4 py-2.5 text-sm font-semibold text-white shadow-lg transition-transform duration-200 hover:scale-[1.02]"
                style={{
                  background: "linear-gradient(135deg, #F50537 0%, #C4042C 100%)",
                  boxShadow: "0 8px 24px -8px rgba(245, 5, 55, 0.5)",
                }}
              >
                Subscribe
              </button>
            </div>
          </>
        ) : (
          <>
            <h3 className="mb-2 text-xl font-semibold tracking-tight text-white">
              This one's for premium members
            </h3>
            <p className="mb-7 max-w-[280px] text-sm leading-relaxed text-gray-400">
              Upgrade your plan to unlock this and the rest of the premium library.
            </p>
            <div className="flex w-full gap-3">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 rounded-lg border border-[#333] px-4 py-2.5 text-sm font-medium text-gray-400 transition-colors hover:border-[#555] hover:text-white"
              >
                Not now
              </button>
              <Link
                to={RouteName.SubscriptionPlanRoute}
                onClick={onClose}
                className="flex-1 rounded-lg px-4 py-2.5 text-center text-sm font-semibold text-white shadow-lg transition-transform duration-200 hover:scale-[1.02]"
                style={{
                  background: "linear-gradient(135deg, #F50537 0%, #C4042C 100%)",
                  boxShadow: "0 8px 24px -8px rgba(245, 5, 55, 0.5)",
                }}
              >
                View plans
              </Link>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default PremiumContentModal;